import {
  LETTERS_NUMBERS_HYPHENS_UNDERSCORES_REGEXP_LABEL,
  LETTERS_NUMBERS_SPACES_HYPHENS_COLONS_SLASHES_REGEXP_LABEL,
} from 'shared/constants/error-labels';
import {
  LETTERS_NUMBERS_HYPHENS_UNDERSCORES_REGEXP,
  LETTERS_NUMBERS_SPACES_HYPHENS_COLONS_SLASHES_REGEXP,
} from 'shared/constants/validation-regex-constants';
import { z } from 'zod';

export const CustomRoleSchema = z.object({
  name: z
    .string()
    .min(2, { message: 'Name must be at least 2 characters long.' })
    .max(50, {
      message: 'Name must be no more than 50 characters long.',
    })
    .regex(LETTERS_NUMBERS_HYPHENS_UNDERSCORES_REGEXP, {
      message: LETTERS_NUMBERS_HYPHENS_UNDERSCORES_REGEXP_LABEL,
    }),
  description: z
    .string()
    // .min(2, { message: 'Description must be at least 2 characters long.' })
    .max(100, {
      message: 'Description must be no more than 100 characters long.',
    })
    .regex(LETTERS_NUMBERS_SPACES_HYPHENS_COLONS_SLASHES_REGEXP, {
      message: LETTERS_NUMBERS_SPACES_HYPHENS_COLONS_SLASHES_REGEXP_LABEL,
    })
    .optional()
    .or(z.literal('')),
  color: z
    .string({
      required_error: 'Color is required',
      invalid_type_error: 'Color must be a string',
    })
    .min(1, 'Color is required'),
  permissions: z.array(z.string()).min(1, 'At least 1 permission is required'),
});
